(function ($) {

    var element_sync_height = function () {
        $('[sync_height]').each(function () {
            var elem = $(this);
            var target = elem.attr('sync-height');
            
            if (target == 'window' || target == '' || target==null) {
                elem.css({ height: window.innerHeight});
            } else {
                var $target = $(target);
                elem.css({ height: $target.height() });
            }
        });

    };

    var element_stretch_height = function () {
        $('[stretch-height]').each(function () {
            var elem = $(this);
            var target = elem.attr('stretch-height');

            if (target == 'window' || target == '' || target == null) {
                elem.css({ height: window.innerHeight - elem.position().top });
            } else {
                var $target = $(target);
                elem.css({ height: $target.height() - elem.position().top });
            }
        });

    };

    $(element_sync_height);
    $(element_stretch_height);

})(jQuery);